module.exports = __webpack_public_path__ + "media/images/redrock/hero-image-winter-2020-small-46c2764e0df776f5fe36dcbb1c93d625.jpg";